import SelectorEngine from '../../utils/dom/selector-engine';
import dataLayer from '../../utils/data-layer';

class PlayerProfile {
    constructor() {
        this._analyticsEl = SelectorEngine.findOne('.js-player-analytics');

        if (!this._analyticsEl) {
            return;
        }

        this.initEvents();
    }

    pushDataLayerEvent() {
        try {
            const { eventName, ...attributes } = this._analyticsEl.dataset;
            dataLayer.push({
                event: eventName,
                ...attributes
            });
        } catch (error) {
            console.log(error.message);
        }
    }

    initEvents() {
        this.pushDataLayerEvent();
    }
}

const globalPlayerProfile = new PlayerProfile();
export default globalPlayerProfile;
